import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import Utils from "models/helper/Utils";
import ProgressBarView from "views/common/ProgressBarView";
import RSVP from "rsvp";

const ProgressBarController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        this._uploadedPercentage = 0;
        this._viewOptions = options || {};
        this._autoRoundPercentage = options && options.autoRoundPercentage !== false; // Default to true
    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },

    /**
     * Normalize percentage value to handle different input formats
     * @private
     * @param {number|string|null} value - Input value (50, "50", "50%", null)
     * @returns {Object} - { isIndeterminate, numericValue, displayValue, cssValue }
     */
    _normalizePercentageValue: function(value) {
        // Handle null/undefined for indeterminate progress
        if (value === null || value === undefined) {
            return {
                isIndeterminate: true,
                numericValue: null,
                displayValue: null,
                cssValue: null
            };
        }
        
        let numericValue;
        
        // Handle string input
        if (typeof value === 'string') {
            // Remove % symbol if present
            const cleanValue = value.replace('%', '');
            numericValue = parseFloat(cleanValue);
            
            // Check if it's a valid number
            if (isNaN(numericValue)) {
                return {
                    isIndeterminate: true,
                    numericValue: null,
                    displayValue: null,
                    cssValue: null
                };
            }
        } else if (typeof value === 'number') {
            numericValue = value;
        } else {
            // Invalid type, treat as indeterminate
            return {
                isIndeterminate: true,
                numericValue: null,
                displayValue: null,
                cssValue: null
            };
        }
        
        // Apply rounding if enabled
        if (this._autoRoundPercentage) {
            numericValue = Math.round(numericValue);
        }
        
        // Clamp to 0-100 range
        numericValue = Math.max(0, Math.min(100, numericValue));
        
        return {
            isIndeterminate: false,
            numericValue: numericValue,
            displayValue: numericValue + '%',
            cssValue: numericValue + '%'
        };
    },

    setPercentageProgress : function(percentageProgress){
        const normalized = this._normalizePercentageValue(percentageProgress);
        
        if (normalized.isIndeterminate) {
            // Set indeterminate progress
            this._percentageProgress = null;
            this.setIndeterminate(true);
            this.view.setPercentageProgress(null);
        } else {
            // Set determinate progress
            this._percentageProgress = normalized.numericValue;
            this.setIndeterminate(false);
            this.view.setPercentageProgress(normalized.displayValue);
        }
    },

    getPercentageProgress : function(){
        return this._percentageProgress;
    },

    setProgressMessage : function(progressMessage){
        this._progressMessage = progressMessage;
        this.view.setProgressMessage(progressMessage);
    },

    setProgressSubMessage: function(progressSubMessage){
        this._progressSubMessage = progressSubMessage;
        this.view.setProgressSubMessage(progressSubMessage);
    },

    setIndeterminate: function(indeterminate){
        this._indeterminate = indeterminate;
        this.view.setIndeterminate(indeterminate);
    },

    buildModelAndRenderView : function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                this.view = new ProgressBarView(this._viewOptions);
                this.view.render();
                resolve();
            } catch (error) {
                reject(error);
            }

        }).bind(this));

    }

});

export default ProgressBarController;